/** @format */

import MainLayout from "@/pages/HRM/MainLayout.vue";
import medicalLetterRoutes from "./childRoutes/medicalLetters/medicalLettersRoutes.js";
const dashboard = () => import("@/pages/HRM/dashboardHRM.vue");
//Main

const routes = [
  {
    path: "dashboard",
    name: "hrm-dashboard",
    component: dashboard,
    // beforeEnter: rules.isHQ,
  },
  {
    path: "medicalLetters",
    name: "hrm-medical-letters",
    component: MainLayout,
    children: medicalLetterRoutes,
  },
];

export default routes;
